export default __webpack_public_path__ + "static/media/profile.c4d9b9c1.png";